'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');
var Border = require('../common/Border');
var appTypes = require('../../types/appTypes');
var assetsHelper = require('../../helper/assetsHelper');
var LabelParts = require('../common/LabelParts');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var _ = require('underscore');
var linkHelper = require('../common/LinkHelper');
var graphicsHelper = require('../../helper/graphicsHelper');
var versionHelper = require('../../helper/versionHelper');

var FOLD_ICON_SIZE = 13;
var CHECK_BOX_SIZE = 12;
var LINE_WIDTH = 1;
var FOLD_ICON_COLOR = 'rgba(102,102,102,1)';

var TreeNode = React.createClass({
    propTypes: {
        selectIndex: React.PropTypes.number.isRequired,
        data: React.PropTypes.object.isRequired,
        itemHeight: React.PropTypes.number.isRequired,
        onClickEvent: React.PropTypes.func.isRequired,
        onDbClickEvent: React.PropTypes.func.isRequired,
        onCheck: React.PropTypes.func.isRequired,
    },

    location: {
        foldStart: 0,
        checkStart: 0,
        iconStart: 0,
        textStart: 0
    },

    adjustLocation: function() {
        var iconSize = (this.props.iconSize && parseInt(this.props.iconSize, 10)) || 16;
        this.location.foldStart = 8;
        this.location.checkStart = 27;
        this.location.iconStart = 45;
        this.location.textStart = this.location.iconStart + iconSize;
        if(!this.props.checkboxvisible) {
            this.location.iconStart -= 18;
            this.location.textStart -= 18;
        }
        if(!this.props.iconVisible) {
            this.location.textStart -= iconSize;
        }

        this.initStyle(iconSize);
        this.setItemShow(iconSize);
    },

    foldStyle: {},
    checkBoxStyle: {},
    iconStyle: {},
    lineStyle: {},
    verticalLine: {},
    backgroundStyle: {},
    linkAreaStyle: {},
    initStyle: function(iconSize) {
        this.foldStyle = this.getStyleBySize(FOLD_ICON_SIZE, this.location.foldStart);
        this.foldStyle.zIndex = 2;

        this.checkBoxStyle = this.getStyleBySize(CHECK_BOX_SIZE-2, this.location.checkStart);
        this.checkBoxStyle.border = '1px solid gray';
        this.checkBoxStyle.background = '#fff';
        this.checkBoxStyle.zIndex = 2;

        this.iconStyle = this.getStyleBySize(iconSize, this.location.iconStart);

        this.textStyle = {
            width: '100%',
            height: this.props.itemHeight,
            lineHeight: this.props.itemHeight + 'px',
            overflow: 'hidden',
            position: 'absolute',
            top: parseInt(((this.props.data.level - 1) * this.props.itemHeight), 10),
            left: 0,
            marginLeft: (this.props.data.hierarchy-1)*19 + this.location.textStart + 6,
            zIndex: 0,
        };

        this.lineStyle = {
            position: 'absolute',
            top: parseInt(((this.props.data.level - 1) * this.props.itemHeight), 10),
            left: 0,
            width: 14+(this.props.data.container.length===0?16:0),
            height: 1,
            marginLeft: this.location.foldStart+FOLD_ICON_SIZE/2 + (this.props.data.hierarchy - 2) * 19,
            marginTop: (this.props.itemHeight - LINE_WIDTH) / 2,
            zIndex: 0,
            borderBottom: '1px dashed #666666'
        };

        var lastChild = this.props.data.container[this.props.data.container.length-1];
        var dy = 0;
        if(lastChild) {
            dy = (lastChild.level - this.props.data.level)*this.props.itemHeight - 6.5;
        }
        this.verticalLine = {
            position: 'absolute',
            top: parseInt(((this.props.data.level - 1) * this.props.itemHeight), 10),
            left: 0,
            width: 1,
            height: dy,
            marginLeft: this.location.foldStart+(FOLD_ICON_SIZE-LINE_WIDTH)/2 + (this.props.data.hierarchy - 1) * 19,
            marginTop: (this.props.itemHeight)/2+6.5,
            zIndex: 0,
            borderLeft: '1px dashed #666666'
        };

        this.backgroundStyle = {
            width: '100%',
            height: this.props.itemHeight,
            overflow: 'hidden',
            display: this.props.height<this.props.data.level*this.props.itemHeight?'none':'block',
            backgroundColor: (this.props.selectIndex === this.props.data.no) ? this.props.selectedColor : undefined,
        };
        this.linkAreaStyle = {
            width: '100%',
            height: this.props.itemHeight,
            top: parseInt(((this.props.data.level - 1) * this.props.itemHeight), 10),
            left: 0,
            position: 'absolute',
            zIndex: 1,
            cursor: this.haveAction ? 'pointer' : 'default'
        };
    },

    isIconShow: true,
    isCheckShow: true,
    isFoldShow: true,
    isItemShow: true,
    isLineShow: true,
    setItemShow: function(iconSize) {
        this.isIconShow = true;
        this.isCheckShow = true;
        this.isFoldShow = true;
        this.isItemShow = true;
        if(this.iconStyle.marginLeft+iconSize > this.props.w) {
            this.isIconShow = false;
        }
        if(this.checkBoxStyle.marginLeft+CHECK_BOX_SIZE > this.props.w) {
            this.isCheckShow = false;
        }
        if(this.foldStyle.marginLeft+FOLD_ICON_SIZE > this.props.w) {
            this.isFoldShow = false;
        }
        //超出边缘的节点不显示
        if(this.props.h<this.props.data.level*this.props.itemHeight) {
            this.isItemShow = false;
        }
        if(this.lineStyle.marginLeft+this.lineStyle.width > this.props.w) {
            this.isLineShow = false;
        }
    },

    getStyleBySize: function(size, beginX) {
        var style = {
            position: 'absolute',
            top: parseInt(((this.props.data.level - 1) * this.props.itemHeight), 10),
            left: 0,
            width: size,
            height: size,
            marginLeft: (this.props.data.hierarchy-1)*19 + beginX,
            marginTop: (this.props.itemHeight - size) / 2,
            zIndex: 2,
        };
        return style;
    },

    render: function () {
        this.adjustLocation();
        var imgSize = (this.props.iconSize && parseInt(this.props.iconSize, 10))+2 || 16;

        this.actionData = this.props.data.actionData;
        this.haveAction = this.actionData.link !== undefined || this.actionData.entry !== undefined || this.actionData.externalURL !== undefined;;
        this.isLinkAction = this.actionData.link !== undefined || this.actionData.externalURL !== undefined;
        var linkAreaClass = 'no-link';
        if (this.haveAction) {
            if (this.isLinkAction) {
                linkAreaClass = 'page-link';
            } else {
                linkAreaClass = 'interactive-link';
            }
        }

        var itemArray = this.props.data.container;
        return (
        <div>
            {this.isItemShow &&
                <div style={this.backgroundStyle} onClick={this.handleClick} onDoubleClick={this.handleFold}>
                    {this.props.treelinevisible &&
                    this.props.data.hierarchy > 1 &&
                        this.isLineShow &&
                        <div style={this.lineStyle}></div>
                    }
                    {this.isFoldShow &&
                        <div style={this.foldStyle} onClick={this.onFoldIconClick}>
                        {this.renderFoldIcon(FOLD_ICON_SIZE, FOLD_ICON_COLOR)}
                    </div>
                    }
                    {this.props.checkboxvisible && this.isCheckShow && <div style={this.checkBoxStyle} onClick={this.checkNode}>
                        {this.renderCheckIcon(this.props.data.check)}
                    </div>}

                    {this.props.iconVisible && this.isIconShow && <div style={this.iconStyle}>
                        {this.renderIcon(this.props.data.type, imgSize, this.props.iconColor || this.props.textColor)}
                    </div>}

                    <label style={this.textStyle} className='tree-label'>
                        {util.Text.convertSpaceToNbsp(this.props.data.text)}
                    </label>

                </div>
            }
            {this.props.treelinevisible && !this.props.data.isClose && <div style={this.verticalLine}></div>}
            {this.haveAction &&
            <div className={linkAreaClass}
                 style={this.linkAreaStyle}
                 onClick={this.onSelfClick}
                 onDoubleClick={this.onSelfDblClick}
                 onMouseDown={this.onSelfMouseDown}
                 onMouseUp={this.onSelfMouseUp}
            ></div>
            }
            {
                this.props.data.isClose ||
                itemArray.map(function (item) {
                    return (<TreeNode
                        {...this.props}
                        data={item}
                        onCheck={this.props.onCheck}
                        key={item.no}
                    />);
                }, this)
            }
        </div>
        );

    },

    renderCheckIcon: function(state) {
        return graphicsHelper.renderCheckIcon(12, state);
    },

    renderFoldIcon: function (size, color) {
        if (this.props.data.container.length === 0) {
            return;
        }
        if (this.props.iconStyle === 'isArrow') {
            return graphicsHelper.renderIconArrow(size, this.props.data.isClose, color);
        } else { // isSquare 以及老版本的情况
            return graphicsHelper.renderIconPlus(size, this.props.data.isClose, color);
        }
    },

    renderIcon: function (type, size, color) {
        if (type === "dir") {
            return graphicsHelper.renderIconDir(size, color);
        } else if (type === "file") {
            return graphicsHelper.renderIconFile(size, color);
        }
    },

    onFoldIconClick: function (e) {
        this.handleFold();
        if (this.haveAction) {
            this.onSelfClick(e);
        }
    },

    handleFold: function () {
        this.props.onDbClickEvent(this.props.data.no);
    },

    handleClick: function () {
        this.props.onClickEvent(this.props.data.no);
    },

    checkNode: function() {
        this.props.onCheck(this.props.data.no);
    },

    onSelfClick: function (e) {
        var k;

        if (this.longPress) {
            return;
        }
        if (this.actionData) {
            k = appTypes.ActionResponseType.NONE;
            if (this.actionData.externalURL) {
                k = appTypes.ActionResponseType.OUTER;
            } else if (this.actionData.link) {
                k = appTypes.ActionResponseType.LINK;
            } else if (this.actionData.entry) {
                k = appTypes.ActionResponseType.INTERACTIVE;
            }
        } else {
            return;
        }
        if (e.button === 0) {
            this.props.events.doSelfClick(e, this.props, k, this.props.data.no);
        } else if (e.button === 2) {
            this.onSelfRightClick(e);
        }
    },

    actionData: undefined,
    haveAction: false,
    isLinkAction: false,
    mousePress: false,
    longPressID: undefined,
    longPress: false,

    onSelfDblClick: function (e) {
        this.props.onDbClickEvent(this.props.data.no);
        if (this.props.events.doSelfDbClick) {
            this.props.events.doSelfDbClick(e, this.props, this.props.data.no);
        }
    },

    onSelfRightClick: function (e) {
        if (this.props.events.doSelfRightClick) {
            this.props.events.doSelfRightClick(e, this.props, this.props.data.no);
        }
    },

    onSelfMouseDown: function (e) {
        this.mousePress = true;
        this.startLongPress(e);
    },

    onSelfMouseUp: function (e) {
        this.mousePress = false;
        this.longPress = false;
        this.stopLongPress();
    },

    stopLongPress: function () {
        if (this.longPressID) {
            clearTimeout(this.longPressID)
        }
        delete this.longPressID;
    },

    startLongPress: function (e) {
        var self = this;
        var data = this.actionData;
        var entry;
        if (data) {
            entry = data.entry;
        }
        if (linkHelper.hasLongPressByEntry(entry)) {
            this.longPressID = setTimeout(function () {
                if (self.mousePress) {
                    self.longPress = true;
                    if (self.props.events.doSelfLongPress) {
                        self.props.events.doSelfLongPress(e, self.props, self.props.data.no);
                    }
                }
                self.stopLongPress();
            })
        }
    }

});

var TreeEx = React.createClass({

    _myPush: function (dirStack, value) {
        dirStack.dirs.push(value);
        dirStack.top++;
    },

    _myPop: function (dirStack, number) {
        for (var i = 0; i < number; i++) {
            dirStack.dirs.pop();
            dirStack.top--;
        }
    },

    _getTop: function (dirStack) {
        if (dirStack.top === -1) {
            return null;
        }
        return dirStack.dirs[dirStack.top];
    },

    parseText: function () {
        var lines = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);

        //1、建立一个目录栈，推入根节点
        var dirStack = {
            top: -1,
            dirs: []
        };
        var root = [];
        this._myPush(dirStack, root);
        var actionDatas = linkHelper.parseComInteractive(this.props);

        for (var i = 0; i < lines.length; i++) {
            //2、判断目标层级，大于栈顶级别，放入栈顶目录，小于等于栈顶级别，弹出（差值+1）个栈顶目录,再放入栈顶目录
            var level = 1;
            var line = lines[i].trim();
            for (var j = 0; j < line.length; j++) {
                if (line.charAt(j) === ".") {
                    level++;
                }
                else {
                    break;
                }
            }

            //找到父节点
            if (dirStack.top >= level) {
                this._myPop(dirStack, dirStack.top + 1 - level);   //弹出差值+1个元素，当前栈顶就是父节点
            }

            //3、新建节点项
            var item = {
                "no": i,
                "text": "",
                type: "",
                "hierarchy": (dirStack.top + 1),
                "container": [],
                "isClose": false,
                "level": 0,
                "check": "false",
                actionData: actionDatas[i]
            };

            var re = /^\.*\[[+|-]\].*$/;
            if (re.test(line)) {       //检查是否目录
                var text = line.replace(/^\.*\[[+|-]\]/, "");     //提取节点名
                item.text = text;
                item.type = "dir";
                var state = line.match(/\[[+|-]\]/g);    //提取目录状态（+号展开|-号收缩）
                if (state[0] === "[+]") {
                    item.isClose = true;
                }
            }
            else {
                var text = line.replace(/^\.*/, "");
                item.text = text;
                item.type = "file";
            }

            //4、将当前节点放入栈顶目录（位于栈顶的目录为父目录）的容器中
            this._getTop(dirStack).push(item);

            //4、若新节点是目录，压入目录栈
            this._myPush(dirStack, item.container);

        }

        return root;
    },

    itemArray: undefined,
    itemPosition: 0,

    getInitialState: function () {
        return {
            selectedIndex: this.props.selectedIndex,
            dbClickIndex: -1,
            mySwitch: true
        };
    },

    componentWillMount: function () {
        this.itemHeight = this.props.itemHeight;
        this.itemArray = this.parseText();
        this.resetLevel(this.itemArray);
    },

    searchTree: function (root, dbClickIndex) {
        if (dbClickIndex < 0) {
            return;
        }
        for (var i = 0; i < root.length; i++) {
            var index = root[i].no;
            if (index === dbClickIndex) {
                root[i].isClose = !root[i].isClose;
                return;
            }
            this.searchTree(root[i].container, dbClickIndex);
        }
    },

    resetLevel: function (root, index) {
        for (var i = 0; i < root.length; i++) {
            this.itemPosition = this.itemPosition + 1;
            root[i].level = this.itemPosition;
            if (!root[i].isClose) {
                this.resetLevel(root[i].container);
            }
        }
    },

    setChildCheck: function(root, checkValue) {
        var children = root.container;
        for(var i=0;i<children.length;i++) {
            children[i].check = checkValue;
            this.setChildCheck(children[i], checkValue);
        }
    },

    setRootCheck: function(root) {
        var checkNum = 0;
        var unCheckNum = 0;
        var children = root.container;
        for(var i=0;i<children.length;i++) {
            if(children[i].container.length > 0) {
                this.setRootCheck(children[i]);
            }
            if(children[i].check === 'true') {
                checkNum++;
            }
            if(children[i].check === 'false') {
                unCheckNum++;
            }
        }
        if(checkNum === children.length) {
            root.check = 'true';
        } else if(unCheckNum === children.length) {
            root.check = 'false';
        } else {
            root.check = 'half';
        }
    },

    resetCheck: function(root, index) {
        if(root.no === index) {
            var checkValue = 'false';
            if(root.check === 'true' || root.check === 'half') {
                checkValue = 'false';
            } else if(root.check === 'false') {
                checkValue = 'true';
            }
            root.check = checkValue;
            this.setChildCheck(root, checkValue);
            return;
        }
        var children = root.container;
        for(var i=0;i<children.length;i++) {
            var node = children[i];
            this.resetCheck(node, index);
        }
    },

    onCheck: function(index) {
        for(var i=0;i<this.itemArray.length;i++) {
            this.resetCheck(this.itemArray[i], index);
            this.setRootCheck(this.itemArray[i]);
        }
    },

    render: function () {
        var borderStyle = styleHelper.StyleUtil(this.props).text().border().size().base().background().style;
        return (<div style={borderStyle}>
            <div style={{
                height: '100%',
                width: this.props.verticalScrollbarShow ? (styleHelper.getWidth(this.props) - 16) : '100%'
              }}>
                {
                    this.itemArray.map(function (item) {
                        return (<TreeNode {...this.props}
                            key={item.no}
                            data={item}
                            selectIndex={this.state.selectedIndex}
                            dbClickIndex={this.state.dbClickIndex}
                            itemHeight={this.itemHeight}
                            onClickEvent={this._onClick}
                            onDbClickEvent={this._onDbClick}
                            onCheck={this.onCheck}
                        />);
                        }, this)
                    }
            </div>
            {
                this.props.verticalScrollbarShow &&
                <VerticalScrollBar value={parseInt(this.props.verticalScrollbarProgress, 10)}/>
                }
        </div>);
    },

    _onClick: function (no) {
        var index = undefined;
        if (arguments.length === 1) {
            index = arguments[0];
        } else if (arguments.length === 2) {
            index = arguments[1];
        }
        if (!_.isUndefined(index))
            this.setState({selectedIndex: index});
    },

    _onDbClick: function (no) {

        var dbClickIndex = undefined;
        if (arguments.length === 1) {
            dbClickIndex = arguments[0];
        } else if (arguments.length === 2) {
            dbClickIndex = arguments[1];
        }
        if (!_.isUndefined(dbClickIndex)) {
            var s = !this.state.mySwitch;
            //递归搜索树，修改双击节点状态（展开|收缩）
            this.searchTree(this.itemArray, dbClickIndex);
            this.itemPosition = 0;
            this.resetLevel(this.itemArray);
            this.setState({mySwitch: s});
        }
    },

    componentDidMount: function () {
        $(ReactDOM.findDOMNode(this)).bind('itemClick', this._onClick);
        $(ReactDOM.findDOMNode(this)).bind('itemDbClick', this._onDbClick);
    }
});

var NodeType = {None: 1, Expansion: 2, Close: 3, File: 4};



var TreeItem = React.createClass({
    propTypes: {
        selected: React.PropTypes.bool.isRequired,
        data: React.PropTypes.object.isRequired,
        itemHeight: React.PropTypes.number.isRequired,
        onClickEvent: React.PropTypes.func.isRequired
    },

    render: function () {
        var imgStyle;
        var textStyle;
        var imgSize;

        var backgroundStyle = {
            width: '100%',
            height: this.props.itemHeight,
            backgroundColor: this.props.selected ? this.props.selectedColor : undefined
        };

        imgSize = (this.props.iconSize && parseInt(this.props.iconSize, 10)) || 16;

        imgStyle = {
            float: 'left',
            width: imgSize,
            height: imgSize,
            marginLeft: 4 + this.props.data.hierarchy * 20,
            marginTop: (this.props.itemHeight - imgSize) / 2
        };

        textStyle = {
            lineHeight: this.props.itemHeight + 'px'
        };

        return (<div style={backgroundStyle} onClick={this.props.onClickEvent}>
            <div style={imgStyle}>
                {this.renderIcon(imgSize, this.props.iconColor || this.props.textColor)}
            </div>
            <label style={textStyle}>
                {util.Text.convertSpaceToNbsp(this.props.data.text)}
            </label>
        </div>);
    },
    renderIcon: function (size, color) {
        var parentSize = Math.round(size * 0.8);
        if (this.props.iconStyle === 'isArrow') {
            if (this.props.data.nodeType === NodeType.Close) {
                return this.renderIconArrow(parentSize, false, color);
            } else if (this.props.data.nodeType === NodeType.Expansion) {
                return this.renderIconArrow(parentSize, true, color);
            }
        } else { // isSquare 以及老版本的情况下
            if (this.props.data.nodeType === NodeType.Close) {
                return this.renderIconDir(parentSize, false, color);
            } else if (this.props.data.nodeType === NodeType.Expansion) {
                return this.renderIconDir(parentSize, true, color);
            }
        }
        return this.renderIconFile(size, color);
    },
    renderIconDir: function (size, expanded, color) {
        return (
            <svg width={size} height={size} viewBox="0 0 20 20">
                <rect x="1" y="1" width="18" height="18" stroke={color} fill="none" strokeWidth="2"/>
                <line x1="4" y1="10" x2="16" y2="10" stroke={color} strokeWidth="2"/>
                {expanded && <line x1="10" y1="4" x2="10" y2="16" stroke={color} strokeWidth="2"/>}
            </svg>
        )
    },
    renderIconFile: function (size, color) {
        return (
            <svg width={size} height={size} viewBox="0 0 20 20">
                <path d="M 1 1 L 8 0 L 8 8 L 16 8 L 16 19 L 0 19 Z M 8 0 L 16 8" strokeWidth="2" stroke={color}
                      fill="none"/>
            </svg>
        )
    },
    renderIconArrow: function (size, expanded, color) {
        if (expanded) {
            return (
                <svg width={size} height={size} viewBox="0 0 20 20">
                    <line x1="1" y1="1" x2="9" y2="9" stroke={color} strokeWidth="2"/>
                    <line x1="9" y1="9" x2="18" y2="1" stroke={color} strokeWidth="2"/>
                </svg>
            );
        }
        return (
            <svg width={size} height={size} viewBox="0 0 20 20">
                {expanded || <line x1="1" y1="1" x2="9" y2="9" stroke={color} strokeWidth="2"/>}
                <line x1="1" y1="18" x2="9" y2="9" stroke={color} fill="none" strokeWidth="2"/>
                {expanded && <line x1="9" y1="9" x2="18" y2="18" stroke={color} strokeWidth="2"/>}
            </svg>
        );
    }
});

var TreeOld = React.createClass({

    _parseItemText: function (text) {
        var resultObj = {
            hierarchy: 0,
            nodeType: NodeType.None,
            text: ''
        };

        var length = text.length;
        var index = 0;
        var bracket = false;
        var ch;
        var isLoop = true;

        while ((index < length) && isLoop) {
            ch = text.charAt(index);
            switch (ch) {
                case '.':
                    resultObj.hierarchy = resultObj.hierarchy + 1;
                    break;
                case '[':
                    bracket = true;
                    break;
                case ']':
                    bracket = false;
                    isLoop = false;
                    break;
                case '+':
                    if (bracket) {
                        resultObj.nodeType = NodeType.Expansion;
                    } else {
                        isLoop = false;
                    }
                    break;
                case '-':
                    if (bracket) {
                        resultObj.nodeType = NodeType.Close;
                    } else {
                        resultObj.nodeType = NodeType.File;
                        isLoop = false;
                    }
                    break;
                default:
                    isLoop = false;
            }
            index = index + 1;
        }

        resultObj.text = text.substring(index, text.length);

        return resultObj;

    },

    _getItemArray: function () {
        var resultArray = [];
        var textArray = util.Text.delimitText(util.Text.removeLastEmptyRow(styleHelper.getText(this.props)), util.Text.DM_RETURN);

        textArray.forEach(function (text) {
            resultArray.push(this._parseItemText(text.trim()));
        }.bind(this));

        return resultArray;
    },

    getInitialState: function () {
        return {
            selectedIndex: this.props.selectedIndex
        };
    },

    componentWillMount: function () {
        var size = AutoSizeHelper.getComAutoSize(this.props, '^p');
        this.itemHeight = Math.round(size.height + 2 * 7.8);
    },

    render: function () {
        var itemArray = this._getItemArray();
        var borderStyle = styleHelper.StyleUtil(this.props).text().border().size().base().background().style;
        return (<div style={borderStyle}>
            <div style={{
        height: '100%',
        width: this.props.verticalScrollbarShow ? (styleHelper.getWidth(this.props) - 16) : '100%'
      }}>
                {
                    itemArray.map(function (item, index) {
                        return (<TreeItem {...this.props}
                            key={index}
                            data={item}
                            selected={index === this.state.selectedIndex}
                            itemHeight={this.itemHeight}
                            onClickEvent={this._onClick.bind(this, null, index)}
                        />);
                        }.bind(this))
                    }
            </div>
            {
                this.props.verticalScrollbarShow &&
                <VerticalScrollBar value={parseInt(this.props.verticalScrollbarProgress, 10)}/>
                }
        </div>);
    },

    _onClick: function (e, index) {
        this.setState({selectedIndex: index});
    },

    componentDidMount: function () {
        $(ReactDOM.findDOMNode(this)).bind('itemClick', this._onClick);
    }
});

/**
 * Tree外壳，根据版本选择具体的Tree实现
 */
var Tree = React.createClass({

    render: function () {
        var isOldVersion = versionHelper.isPageVersionLowerThan4_5();

        if (isOldVersion) {
            return <TreeOld {...this.props}/>;
        }
        return <TreeEx {...this.props}/>;
    },

});

module.exports = Tree;



// WEBPACK FOOTER //
// ./src/views/Components/TreeEx.jsx